import { inject, Injectable, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  constructor() {}
  #activeRoute = inject(ActivatedRoute);

  scrollFragment() {
    this.#activeRoute.fragment.subscribe((fragment) => {
      if (fragment) {
        const element = document.getElementById(fragment);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" }); // scroll smoothly to the element
        }
      }
    });
  }
  scrollElementById(element_id: string) {
    const element = document.getElementById(element_id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // scroll smoothly to the element
    }
  }
}
